// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"373":"74e0c369459e25cf","629":"1641e978eb94838b"}[chunkId] + ".js";
};